import Payments from '../features/payments';

export const PaymentsPage = () => <Payments />;
